<template>
  <div class="commission">
    <div class="list">
      <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
        :loading-text="$t('Hint.loading')">
        <template v-if="list.length">
          <div v-for="(item, index) in list" :key="`item_${index}`" class="item_wrap app_card">
            <div class="_item">
              <div class="label">{{ $t('佣金来源') }}</div>
              <div class="value">{{ item.from_userphone }}</div>
            </div>
            <div class="_item">
              <div class="label">{{ $t('佣金金额') }}</div>
              <div class="value">{{ $money(item.commission || '0.00') }}</div>
            </div>
            <div class="time">{{ $format(item.indate) }}</div>
          </div>
        </template>
        <div class="list_not" v-else>
          <img :src="require('@/assets/Img/null/null.png')" alt="">
        </div>
      </List>
    </div>
  </div>
</template>
<script>
import { Toast, List } from 'vant';
import { } from "@/api"
import { post } from "@/utils/newRequest";
export default {
  components: {
    Toast,
    List
  },
  data() {
    return {
      list: [],
      page: 0,
      loading: false,
      hasMore: true,
    }
  },
  methods: {
    async getList() {
      this.loading = false;
      this.page++;
      try {
        const { lists, hasMorePages } = await post("/agent/commission/records", {
          pagesize: 20,
          page: this.page,
        });
        const realList = lists;
        this.hasMore = hasMorePages;
        this.list = [...this.list, ...realList];
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = true;
        // this.loading = false;
        this.page--;
      }
    },
  }
}
</script>
<style lang="less" scoped>
.commission {
  .list {
    margin-top: 12px;

    :deep(.van-list) {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .item_wrap {
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 4px;

      ._item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;

        .label {
          font-size: 12px;
          color: #7a8597;
        }

        .value {
          font-size: 16px;
          color: #0f172a;
          font-weight: 600;
        }
      }
      .time{
        font-size: 12px;
        color: #7a8597;
        text-align: right;
      }
    }

    .list_not {
      padding: 32px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 160px;
        height: 160px;
        display: block;
      }

      span {
        color: #7a8597;
        font-size: 14px;
        padding: 16px 0 14px;
      }
    }
  }

}
</style>